/* eslint-disable */
import { icon, node, isInViewport } from '~/util/dom';
import Content from './content';
import { CONFIG } from "~/config";
import { timePassed } from "~/util/format";
import { _ } from "~/i18n";
import { useScroll } from "~/util/usescroll";
import { INewsResponse } from '~/util/providers/news';

const NEWS_COUNT = 2;
const SECTION = "fulltext_articles";

export default class News extends Content {
	_scrollWasBind: boolean;
	_scrollId: number | null;
	_scrollListener: ReturnType<typeof useScroll>;

	constructor(data, options) {
		super(data, options);

		this._scrollListener = null;
	}

	destroy() {
		this._removeScrollEvent();
	}

	_build() {
		this._dom.container.classList.add("content-news");
		this._dom.container.classList.add("empty");

		this._load();
	}

	async _load() {
		try {
			const response = await fetch(`${CONFIG.requestUrl}/poiagghttp/poi_news/${this._data}/`);
			const json = await response.json() as INewsResponse;

			if (response.status >= 200 && response.status < 300) {
				this._buildFromData(json);
			}
		} catch (exc) {
			console.log(exc);
		}
	}

	_buildFromData(json: INewsResponse) {
		if (!Array.isArray(json.documents) || json.documents.length === 0) {
			return;
		}

		const title = node("h3", { textContent: _("detail.content.news.title") });
		const items = node("div", { className: "items" });

		json.documents.slice(0, NEWS_COUNT).forEach(data => {
			const item = node("a", { className: "item", href: data.snippet.url, target: "_blank", rel: "noreferrer" });
			item.setAttribute("data-log-ignore", "true");
			item.addEventListener("pointerdown", () => {
				this._analytics("click", {
					text: data.snippet.title,
					url: data.snippet.url,
				});
			});
			const coverPhoto = data.thumbnails?.filter(item => item.type === "mainImage")[0]?.url;
			const img = node("img", { className: "cover", src: coverPhoto || "/img/header-placeholder.svg" });
			const desc = node("p", { className: "desc", textContent: data.snippet.title });
			const date = node("span", { className: "date", textContent: data.attributes?.publicationDate ? timePassed(new Date(data.attributes.publicationDate * 1000)) : "" });
			const source = node("span", { className: "source", textContent: data.snippet.domain });

			if (CONFIG.wasmEnabled && coverPhoto) {
				img.crossOrigin = "anonymous";
			}

			item.append(img, desc, date, source);
			items.append(item);
		});

		this._dom.container.append(title, items);

		if (json.documents.length > NEWS_COUNT) {
			const moreNew = node("div", { className: "more-news" });
			const link = node("a", { href: json.urlMore, target: "_blank", rel: "noreferrer" });
			link.setAttribute("data-log-ignore", "true");
			link.addEventListener("pointerdown", () => {
				this._analytics("click", {
					text: "více novinek",
					url: json.urlMore,
				});
			});
			link.append(node("span", { textContent: _("detail.content.news.moreNews") }), icon("arrow-right"));
			moreNew.append(link);

			this._dom.container.append(moreNew);
		}

		this._dom.items = items;
		this._dom.container.classList.remove("empty");

		if (this._options.data.showWeather !== false) {
			this._dom.container.classList.add("weather-avail");
		}

		// analytika - i kdyz se clanky nezobrazi
		this._analytics("fulltext_articles_loaded");

		if (isInViewport(this._dom.items)) {
			this._impressAnalytics();
		} else {
			this._scrollListener = useScroll({
				onScroll: () => {
					if (isInViewport(this._dom.items)) {
						this._impressAnalytics();
						this._removeScrollEvent();
					}
				},
			});
		}
	}

	_analytics(action: string, opts?: object) {
		Mapy.getComponent("logger").log(action, {
			id: this._options.data.id,
			source: this._options.data.source,
			typeid: this._options.data.typeId,
			section: SECTION,
			...opts,
		});
	}

	_impressAnalytics() {
		this._analytics("fulltext_articles_show");
	}

	_removeScrollEvent() {
		this._scrollListener && this._scrollListener();
		this._scrollListener = null;
	}
}
